import {
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { Dividers } from '../accordion/accordion.directive';
import { ButtonVariant } from '@zelis/dls/button';
import { IconName } from '@zelis/dls/icons';
import { ExpansionPanelData } from '../expansion-panel/expansion-panel-data';
import { BreakpointObserverService } from '@zelis/dls/breakpoint-helper';

@Component({
  selector: 'zelis-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
})
export class ExpansionPanelComponent {
  @Input() dividers: Dividers = 'static';
  @Input() stroke = true;
  @Input() expanded = false;
  @Input() multi!: boolean;
  @Input() hideToggle = false;
  @Input() expandedButtonVariant!: ButtonVariant;
  @Input() panelData!: ExpansionPanelData[];
  @Input() avatarSrc!: string;
  @Input() buttonColor!: string;
  @Input() buttonVariant!: ButtonVariant;
  @Input() rightIconName!: IconName;
  @Output() analytics? = new EventEmitter<any>();
  @ContentChild(TemplateRef) expansionPanelContent!: TemplateRef<any>;
  @HostBinding() class = 'zelis-dls';

  constructor(public breakpoint: BreakpointObserverService) {}

  handleClick(event: Event, name: string) {
    event.stopPropagation();
    this.analytics?.emit({ action: 'panel_button_clicked', name });
    return event;
  }

  handleToggle(action: string, name: string) {
    this.analytics?.emit({ action, name });
  }
}
